"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MOUSE_UP = exports.MOUSE_DOWN = exports.CLICK = exports.KEY_UP = exports.KEY_PRESS = exports.KEY_DOWN = exports.SUBMIT = exports.INPUT = exports.CHANGE = exports.FOCUS = exports.BLUR = void 0;
// Focus Events
var BLUR = 'BLUR';
exports.BLUR = BLUR;
var FOCUS = 'FOCUS'; // Form Events

exports.FOCUS = FOCUS;
var CHANGE = 'CHANGE';
exports.CHANGE = CHANGE;
var INPUT = 'INPUT';
exports.INPUT = INPUT;
var SUBMIT = 'SUBMIT'; // Keyboard Events

exports.SUBMIT = SUBMIT;
var KEY_DOWN = 'KEY_DOWN';
exports.KEY_DOWN = KEY_DOWN;
var KEY_PRESS = 'KEY_PRESS';
exports.KEY_PRESS = KEY_PRESS;
var KEY_UP = 'KEY_UP'; // Mouse Events

exports.KEY_UP = KEY_UP;
var CLICK = 'CLICK';
exports.CLICK = CLICK;
var MOUSE_DOWN = 'MOUSE_DOWN';
exports.MOUSE_DOWN = MOUSE_DOWN;
var MOUSE_UP = 'MOUSE_UP';
exports.MOUSE_UP = MOUSE_UP;
var _default = {
  BLUR: BLUR,
  FOCUS: FOCUS,
  CHANGE: CHANGE,
  INPUT: INPUT,
  SUBMIT: SUBMIT,
  KEY_DOWN: KEY_DOWN,
  KEY_PRESS: KEY_PRESS,
  KEY_UP: KEY_UP,
  CLICK: CLICK,
  MOUSE_DOWN: MOUSE_DOWN,
  MOUSE_UP: MOUSE_UP
};
exports.default = _default;